import { owcTheme } from 'core/theme/theme.config';
import { PocButton } from 'commons/components/components-wrapper/poc-button.component';
import { PocTypography } from 'commons/components/components-wrapper/poc-typography.component';
import { SettingsCardLayout } from 'modules/settings/settings.style';
import styled from 'styled-components';

export const SettingsCardLayoutStyled = styled(SettingsCardLayout)`
    width: 100%;
`;

export const ActiveDirectoryDataPointsFormHeaderContent = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
`;

export const ActiveDirectoryDataPointsFormMandatoryDescriptionPocTypography = styled(PocTypography)`
    color: ${owcTheme['one-color-interaction-default-intensity-medium']};
`;

export const ActiveDirectoryDataPointsFormFieldsWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
    width: 95%;
    padding: 0 24px;
`;

export const ActiveDirectoryDataPointsOtherFormHeaderContent = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding: 24px 0;
`;

export const ActiveDirectoryDataPointsFormOtherTitlePocTypography = styled(PocTypography)`
    font-weight: bold !important;
    color: ${owcTheme['one-color-interaction-default-intensity-medium']};
`;

export const ActiveDirectoryDataPointsFormOtherDescriptionPocTypography = styled(PocTypography)`
    color: ${owcTheme['one-color-interaction-default-intensity-medium']};
`;

export const ActiveDirectoryDataPointsFormOtherAddPocButton = styled(PocButton)`
    margin-top: 16px;
`;
